import CertidoesUgs from "@/views/interno/CertidoesUGs.vue";

const internoRotas = [
  {
    path: "/certidoes-ugs",
    name: "certidoes-ugs",
    component: CertidoesUgs,
  },
];

export { internoRotas };
